import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  key: 2,
  class: "col-12"
}
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.localCondition.type === 'multiselect')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", null, _toDisplayString(_ctx.localCondition.text), 1),
          ((typeof _ctx.localCondition.options[0] == 'object'))
            ? (_openBlock(), _createBlock(_component_VueMultiselect, {
                key: 0,
                modelValue: _ctx.localCondition.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localCondition.value) = $event)),
                options: _ctx.localCondition.options,
                multiple: true,
                display: "value",
                "custom-label": _ctx.createLabels,
                label: "text",
                "track-by": "value",
                placeholder: _ctx.localCondition.text
              }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]))
            : (_openBlock(), _createBlock(_component_VueMultiselect, {
                key: 1,
                modelValue: _ctx.localCondition.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localCondition.value) = $event)),
                options: _ctx.localCondition.options,
                multiple: true,
                display: "value",
                "custom-label": _ctx.createLabels,
                placeholder: _ctx.localCondition.text
              }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]))
        ]))
      : (_ctx.localCondition.type === 'between')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "OD", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localCondition.value.from) = $event)),
                type: "date",
                class: "form-control shadow-none rounded-0 text-black me-1"
              }, null, 512), [
                [_vModelText, _ctx.localCondition.value.from]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("label", null, "DO", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localCondition.value.to) = $event)),
                type: "date",
                class: "form-control shadow-none rounded-0 text-black me-1"
              }, null, 512), [
                [_vModelText, _ctx.localCondition.value.to]
              ])
            ])
          ]))
        : (_ctx.localCondition.type === 'select')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.localCondition.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localCondition.value) = $event)),
                options: _ctx.localCondition.options
              }, null, 8, ["modelValue", "options"])
            ]))
          : (_ctx.localCondition.type === 'fulltext')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("label", null, _toDisplayString(_ctx.localCondition.text), 1),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localCondition.value) = $event)),
                    type: "text",
                    class: "form-control shadow-none rounded-0 text-black",
                    placeholder: _ctx.localCondition.name
                  }, null, 8, _hoisted_7), [
                    [_vModelText, _ctx.localCondition.value]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "container mt-5" }, null, -1))
  ]))
}